export const mock = (value, timeout = 2000) => {
  return new Promise((resolve) => {
    setTimeout(
      () =>
        resolve({
          data: value,
        }),
      timeout
    );
  });
};

export const getRandomValueBetween = (min, max) => {
  return Math.random() * (max - min) + min;
};
